<template>
  <v-container>
    <v-card title="Turned In">
      <v-card-text>
        <v-data-table-server
          v-model="selected"
          v-model:items-per-page="pagination.limit"
          :items="teams"
          :headers="headersTeam"
          :items-length="count"
          :loading="loading"
          :search="pagination.q"
          item-key="id"
          show-select
          return-object
          @update:options="handleLimitChange">
          <template #item.name="{ item }">
            <router-link
              :to="{
                name: 'AdminYearTeamDetailView',
                params: { yearId, teamId: item.teamCriteria?.team?.id },
              }"
              >{{ item.teamCriteria?.team?.name }}</router-link
            >
          </template>
          <template #item.film="{ item }">
            <div v-if="item.movie">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else color="danger"><v-icon>mdi-alpha-x-circle</v-icon></div>
          </template>
          <template #item.entryForm="{ item }">
            <div v-if="item.submissionEntryForm?.submitted">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else><v-icon color="danger">mdi-alpha-x-circle</v-icon></div>
          </template>
          <template #item.criteria="{ item }">
            <div v-if="filledOutCriteria(item)">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else><v-icon color="danger">mdi-alpha-x-circle</v-icon></div>
          </template>
          <template #item.stillAndTeamVideo="{ item }">
            <div v-if="hasUploadedTeamAndStill(item)">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else><v-icon color="danger">mdi-alpha-x-circle</v-icon></div>
          </template>
          <template #item.cast="{ item }">
            <div v-if="item.castCrew && item.castCrew.length > 0">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else><v-icon color="danger">mdi-alpha-x-circle</v-icon></div>
          </template>
          <template #item.releases="{ item }">
            <div v-if="item.releasesDone">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
            <div v-else><v-icon color="danger">mdi-alpha-x-circle</v-icon></div>
          </template>

          <template v-slot:top>
            <v-text-field
              v-model="pagination.q"
              class="ma-2"
              density="compact"
              placeholder="Search team..."
              hide-details></v-text-field>
          </template>
        </v-data-table-server>
      </v-card-text>
      <v-card-actions v-if="selected.length > 0"> </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
import { IHeaderDTO, IPaginationDTO, ISubmissionDTO, PaginationDTO, SubmissionDTO } from '@/dtos';
import { SNACKSTATUS } from '@/stores/util';
import { useAdminSubmissionStore } from '@/stores/modules/admin';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
interface Props {
  branchId: string;
  yearId: string;
}
const props = defineProps<Props>();
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const submissionStore = useAdminSubmissionStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const query = submissionStore.getAllSubmissions(branchId, yearId, pagination);
const loading = computed(() => query.isLoading.value);
const teams = computed(() => query.data.value?.data ?? []);
const count = computed(() => query.data.value?.count ?? 0);
const selected = ref<ISubmissionDTO[]>([]);
const headersTeam = [
  { title: 'Name', key: 'name', align: 'start', sortable: true },
  {
    title: 'Film',
    key: 'film',
    sortable: false,
  },
  {
    title: 'Entry Form',
    key: 'entryForm',
    sortable: false,
  },
  {
    title: 'Use of Criteria',
    key: 'criteria',
    sortable: false,
  },
  {
    title: 'Still & Team Video',
    key: 'stillAndTeamVideo',
    sortable: false,
  },
  {
    title: 'Cast & Crew',
    key: 'cast',
    sortable: false,
  },
  {
    title: 'Releases',
    key: 'releases',
    sortable: false,
  },
  { title: '', key: 'action', sortable: false },
] as IHeaderDTO[];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};

const filledOutCriteria = (item: SubmissionDTO) => {
  return (
    (
      item.teamCriteria?.criteriaRelations?.filter(
        (c) =>
          c.use_of_criteria != null && c.use_of_criteria != undefined && c.use_of_criteria !== '',
      ) || []
    ).length > 0 || false
  );
};

const hasUploadedTeamAndStill = (item: SubmissionDTO) => {
  return (
    item.teamVideo?.id !== undefined &&
    item.teamVideo?.id !== '' &&
    item.screenshot?.id !== undefined &&
    item.screenshot?.id !== ''
  );
};
</script>
